import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Arise4uBlackLogo from '../../assets/images/logo/arise logo-01 1.svg';
import UploadDocumentImage from '../../assets/images/popups/upload_document.png';



const PaymentUploadDocumentModal = ({ id, onClose, show = false, onSubmit }) => {

  const [selectedFile, setSelectedFile] = useState(null);
  
   const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUploadClick = () => {
    document.getElementById('file-upload-input').click();
  };

  const handleSubmit  = () => {
     if (!selectedFile) {
      alert('Please select a file to upload.');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);
    console.log("formData: ", formData);
    
    onSubmit(selectedFile);
  }

  return (
    <>
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
        <Modal.Header>
          <div className="logo-box">
              <img
                src={Arise4uBlackLogo}
                alt="Arise4u Black Logo"
                className="arise4u-black-logo"
              />
            </div>
            <button
              type="button"
              className="btn-close1 font-bold fs-5"
              onClick={onClose}
            >
              X
            </button>
        </Modal.Header>
        <Modal.Body>
           <div className='popup-upload-title-box mt-minus-60 d-flex flex-column justify-content-center align-items-center'>
              
              <div className='design-box my-3' >
                <img
                  src={UploadDocumentImage}
                  alt='Upload Document Image'
                  className='popup-upload-document-img cursor-pointer'
                  onClick={handleUploadClick}

                />
                <input
                  id="file-upload-input"
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleFileChange}
                />

                {/* Upload Button */}
                {/* <div className='popup-upload-btn-box d-flex justify-content-center align-items-center py-3'> */}
                  
                </div>
                <div className='btn-design d-flex flex-column justify-content-center align-items-center'>
                    <p className='mb-0 txt-blue font-regular fs-6' onClick={handleUploadClick}>Choose File</p>
                    <p className='mb-0 txt-red font-regular font-size-12'>(File size must not exceed 5 MB, Allowed formats are: JPG, JPEG, PNG)</p>
                  </div>
                {selectedFile && (
                  <p className='text-center mt-2 font-regular fs-6'><strong>Selected:</strong> {selectedFile.name}</p>
                )}

              {/* </div> */}
              <p className='font-bold text-center txt-blue fs-2 mb-0'>Upload the screenshot</p>
              <p className='font-bold text-center fs-2 mb-0 mt-minus-10'>of the payment once completed.</p>
            </div>
            <div className='popup-qrcode-btn-box d-flex justify-content-center align-items-center py-3 '>
              <div className='btn-design d-flex justify-content-center align-items-center cursor-pointer' onClick={handleSubmit}>
                <p className='mb-0 txt-white font-regular-four fs-5'>Upload</p>
                <svg className='ms-2' width="20" height="20"  data-name="Layer 1" fill='white' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4.38 12.19 8.57 8 4.38 3.81l1.53-1.52L11.62 8l-5.71 5.71-1.53-1.52z"/></svg>
              </div>
            </div>
            <div className='d-flex flex-column justify-content-center align-items-center pb-5'>
              <p className='font-regular text-center mb-0'>Please ensure to have the transaction number</p>
              <p className='font-regular text-center mb-0'>mentioned in the screenshot before uploading</p>
            </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PaymentUploadDocumentModal;
